// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"9b038c62","500":"13a00e49","978":"97fafddf"}[chunkId] + ".chunk.js";
};